import { ICSSInJSStyle } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
interface DeviceSelectDropdownStyles {
  selectDeviceDropdown: ICSSInJSStyle;
}

export const useDeviceSelectDropdownStyles: () => DeviceSelectDropdownStyles =
  () => {
    const { main } = useFluentColorScheme();

    return {
      selectDeviceDropdown: {
        maxWidth: "272px",
        width: "300px",
        height: "32px",
        background: main.background,
        borderRadius: "3px",
      },
    };
  };
